// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".questionnaire-container {\n  background-color: #fff;\n  padding: 20px;\n  border: 1px solid #ededed;\n  box-sizing: border-box;\n  border-radius: 3px;\n}\n", ""]);
// Exports
module.exports = exports;
